/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NormativeDocumentScopeFilter } from './normativeDocumentScopeFilter';


export interface NormativeDocumentIncludeFilterItems { 
    relation?: NormativeDocumentIncludeFilterItems.RelationEnum;
    scope?: NormativeDocumentScopeFilter;
}
export namespace NormativeDocumentIncludeFilterItems {
    export type RelationEnum = 'company' | 'area' | 'type' | 'owner' | 'versions';
    export const RelationEnum = {
        Company: 'company' as RelationEnum,
        Area: 'area' as RelationEnum,
        Type: 'type' as RelationEnum,
        Owner: 'owner' as RelationEnum,
        Versions: 'versions' as RelationEnum
    };
}


